import { createContext } from 'react';

export default createContext({ size: 'm', value: '', setValue: () => {} });
